import { RootState } from '../store';

export const getDialog = (state: RootState) =>
  state.dialog.dialog;

export const isDialogOpen = (state: RootState) =>
  state.dialog.open;
